"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconGlobe = _interopRequireDefault(require("../../images/icon-globe.svg"));
require("./MobileNav.scss");
var _downCaretDarkBlue = _interopRequireDefault(require("../../images/down-caret-dark-blue.svg"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TopMobileNav = props => {
  const {
    mouse,
    links,
    hamburgerIsOpen,
    closeAll,
    disableLogin,
    disableLanguageRegion = true,
    currentOpenMenu,
    searchFieldValue,
    handleSearchSubmit,
    languageSelectorData,
    languageSelectorDeployed,
    handleLanguageSelectorDeployed,
    loginPage,
    isHidden,
    isAuthenticated,
    userProfile,
    logout,
    login,
    Link,
    authLabels
  } = props;
  const toggleWithEnter = (event, text) => {
    if (!mouse) {
      // checks that a user hits the enter key to open the modal
      if (event.keyCode === 13) {
        handleLanguageSelectorDeployed(text);
      }
    }
  };
  const generateLinks = (currentOpenMenu, publicOnly) => {
    if (links) {
      return links?.filter(link => {
        return publicOnly ? link.isPublicPage : link;
      })?.filter(link => link?.url)?.map(link => {
        const {
          url,
          text
        } = link;
        return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
          tabIndex: mouse ? "" : "0",
          key: text,
          to: url,
          className: `ter-top-mobile-nav__link-wrapper ${currentOpenMenu !== null ? "ter-top-mobile-nav__link-wrapper--inactive" : ""} ${!hamburgerIsOpen ? "ter-top-mobile-nav__link-wrapper--hidden" : ""} ${mouse ? "ter-top-mobile-nav__link" : "ter-top-mobile-nav__link tabFocus"}`,
          target: link.external ? "_blank" : "_self",
          Link: Link,
          onClick: closeAll
        }, text);
      });
    } else {
      return [];
    }
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (searchFieldValue.length === 0) {
      return;
    }
    handleSearchSubmit();
  };
  //disable search is handled by mobile section in <NavBar />
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, disableLogin || !disableLogin && isAuthenticated ? generateLinks(currentOpenMenu) : generateLinks(currentOpenMenu, true), !disableLanguageRegion && languageSelectorData?.languages && /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-top-mobile-nav__location-wrapper ${currentOpenMenu !== null ? "ter-top-mobile-nav__location-wrapper--inactive" : ""} ${!hamburgerIsOpen ? "ter-top-mobile-nav__location-wrapper--hidden" : ""} ${mouse ? "" : "tabFocus"}`,
    onKeyDown: e => toggleWithEnter(e),
    onClick: () => handleLanguageSelectorDeployed(),
    tabIndex: mouse ? "" : "0",
    "aria-haspopup": "menu",
    "aria-expanded": languageSelectorDeployed
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _iconGlobe.default,
    width: "16",
    alt: "globe wireframe icon",
    className: "ter-top-mobile-nav__globe-icon"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-top-mobile-nav__location",
    style: {
      whiteSpace: "pre"
    }
  }, languageSelectorData?.regions?.length > 1 && languageSelectorData?.settings?.region && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, languageSelectorData?.settings?.region, " | "), languageSelectorData?.settings?.language?.nativeField), /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-mobile-mega-menu__caret ter-mobile-menu__caret--down`,
    src: _downCaretDarkBlue.default,
    alt: "caret icon"
  })));
};
var _default = TopMobileNav;
exports.default = _default;